import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LoginModal } from '@/components/auth/LoginModal'
import { Navigation } from './landing/Navigation'
import { Hero } from './landing/Hero'
import { FeaturesGrid } from './landing/FeaturesGrid'
import { HowItWorks } from './landing/HowItWorks'
import { FinalCTA } from './landing/FinalCTA'
import { Footer } from './landing/Footer'
import './landing-page.css'

export function LandingPage() {
	const navigate = useNavigate()
	const [loginOpen, setLoginOpen] = useState(false)

	function handleGetStarted() {
		setLoginOpen(true)
	}

	function handleLoginSuccess() {
		setLoginOpen(false)
		navigate('/content')
	}

	return (
		<div className="landing-page">
			<a href="#main" className="landing-skip-link">Skip to main content</a>

			<Navigation onLoginClick={handleGetStarted} />

			<main id="main">
				<Hero onGetStarted={handleGetStarted} />
				<HowItWorks />
				<FeaturesGrid />
				<FinalCTA onGetStarted={handleGetStarted} />
			</main>

			<Footer />

			<LoginModal
				open={loginOpen}
				onOpenChange={setLoginOpen}
				onSuccess={handleLoginSuccess}
			/>
		</div>
	)
}
